<template>
    <div class="pws_cont">
        <div class="pws_line_cont">
            <div class="pws_line" v-bind:style="{ 'width': LinePercent+'%', 'background-color':LineColor }"></div>
        </div>
        <div class="pws_title">{{Title}}</div>
    </div>
</template>

<script>


export default {
  name: 'GrcPasswordStrength',
  components: {
  },
  props: {
  },
  data () {
      return {
          value:"",
          LinePercent:0,
          MinLength:12,
          colorList: ['crimson', 'orange', 'green'],
          AlphaChars: "qwertzuiopőúasdfghjkléáűíyxcvbnmöüó",
          NumChars: "0123456789",
          LineColor: "crimson",
          isOK: false,
          Title: "",
      }
  },
  model: {
  },  
  methods:{
      Init(pMinLength, pTitle)
      {
          if (pMinLength<1) { this.pMinLength = 1; }
          else { this.MinLength = pMinLength; }

          this.Title = pTitle;

          this.SetValue(this.value);
      },

      GetStatusz()
      {
          return this.isOK;
      },

      SetValue(pValue)
      {
          this.value = pValue;
          var VL = this.value.length;
          if (VL > this.MinLength) { VL = this.MinLength; }
          var LP = Math.ceil((VL/this.MinLength)*100);
          if (LP > 100) { LP = 100; }
          this.LinePercent = LP;

          var colorIndex = 0;

          var kisbetu = 0;
          var nagybetu = 0;
          var szam = 0;
          var egyeb = 0;

          for(var i=0; i<pValue.length; i++)
          {
            var isAlpha = 0;
            var isNum = 0;

            if ( this.AlphaChars.indexOf(pValue.substr(i,1)) >=0 ) { kisbetu = 1; isAlpha = 1; }
            if ( this.AlphaChars.toUpperCase().indexOf(pValue.substr(i,1)) >=0 ) { nagybetu = 1; isAlpha = 1; }

            if ( this.NumChars.indexOf(pValue.substr(i,1)) >=0 ) { szam = 1; isNum = 1; }            

            if ( (isAlpha + isNum) == 0) { egyeb = 1; }
          }

          colorIndex = kisbetu + nagybetu + egyeb + szam;
          if (colorIndex > 3) { colorIndex = 3; }
          colorIndex = colorIndex - 1;
          if (colorIndex < 0) { colorIndex = 0; }

          if ((colorIndex == 2)&&(pValue.length>=this.MinLength)) { this.isOK = true; }
          else { this.isOK = false; }

          this.LineColor = this.colorList[colorIndex];

      },


  },
  created()
  {

  },
  mounted()
  {

  }

}


</script>


<style scoped>

.pws_cont
{
    width:100%;
    box-sizing: border-box;
    background-color: transparent;
}

.pws_title
{
    width:100%;
    box-sizing: border-box;
    background-color: transparent;
    font-size: 13px;
    line-height: 13px;
    margin-bottom: 4px;
    margin-top:4px;
    color:#444;
}

.pws_line_cont
{
    width:100%;
    box-sizing: border-box;
    background-color: transparent;
    height:6px;
    border-radius: 3px;
    background-color: #e6e6e6;
}

.pws_line
{
    width:0%;
    box-sizing: border-box;
    background-color: transparent;
    height:6px;
    border-radius: 3px;
}

</style>